/* Koreachi | global.js  — announcement bar + mobile nav */
(function () {
  'use strict';

  /* ---- Announcement bar dismiss (persists per message) ---- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var key = 'koreachi-announcement-dismissed';
    var msg = bar.textContent.trim();
    try {
      if (localStorage.getItem(key) === msg) bar.hidden = true;
    } catch (e) {}
    var close = bar.querySelector('[data-announcement-close]');
    if (close) {
      close.addEventListener('click', function () {
        bar.hidden = true;
        try { localStorage.setItem(key, msg); } catch (e) {}
      });
    }
  });

  /* ---- Newsletter fallback form: submit via AJAX so the page never reloads.
     (Only used when the Klaviyo embed is not active. Klaviyo submits its own
     form via AJAX already.) ---- */
  document.querySelectorAll('.newsletter-band__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button, [type="submit"]');
      if (btn) btn.disabled = true;
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      }).then(finish).catch(finish);

      function finish() {
        var row = form.querySelector('.newsletter-band__row');
        var fine = form.querySelector('.newsletter-band__fine');
        if (row) row.remove();
        if (fine) fine.remove();
        if (form.querySelector('.newsletter-band__success')) return;
        var msg = document.createElement('p');
        msg.className = 'chip newsletter-band__success';
        msg.textContent = form.getAttribute('data-success') || 'Thanks! Check your email for your discount code.';
        form.appendChild(msg);
      }
    });
  });

  /* ---- Mobile nav drawer ---- */
  var nav = document.querySelector('[data-mobile-nav]');
  if (nav) {
    var openBtn = document.querySelector('[data-menu-open]');
    var lastFocus = null;

    function openNav() {
      lastFocus = document.activeElement;
      nav.setAttribute('open', '');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var first = nav.querySelector('a, button');
      if (first) first.focus();
    }
    function closeNav() {
      nav.removeAttribute('open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    if (openBtn) openBtn.addEventListener('click', openNav);
    nav.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', closeNav);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.hasAttribute('open')) closeNav();
    });
  }
})();
